import { render, staticRenderFns } from "./AlbumTemplateZone.vue?vue&type=template&id=e5a560b2&scoped=true&"
import script from "./AlbumTemplateZone.vue?vue&type=script&lang=js&"
export * from "./AlbumTemplateZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumTemplateZone.vue?vue&type=style&index=0&id=e5a560b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a560b2",
  null
  
)

export default component.exports